export default __webpack_public_path__ + "static/media/bg_groupement_adherents.a064d595.jpg";